import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "layout-pc"
};
import loginBoxPC from '@/components/pc/popup/loginBoxPC';
import SignPopupPC from '@/components/pc/popup/SignPopupPC';
import NicknameEditPC from '@/components/pc/popup/NicknameEditPC';
import AvatarUploadPC from '@/components/pc/popup/AvatarUploadPC';
import PalcodePopup from '@/components/popup/PalcodePopup';
import PalcodeSuccessPopup from '@/components/popup/PalcodeSuccessPopup';
import { useActions, useState } from '@/utils/map-state';
import { ref, computed, provide, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
// import { orderBy } from "lodash-es";
import { homeCategoryTable, forumCategoryTable } from "@/composable/commonFunction/categoryTable";
export default {
  __name: 'layoutPC',
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    // const forumActions    = useActions('forum', ['navigateForum'])
    const activeHeaderTab = ref(homeCategoryTable.filter(item => item.home)[0]['key']);
    const categoryTab = ref();
    const previousHeader = ref();
    provide('activeHeaderTab', {
      activeHeaderTab,
      switchHeaderTab
    });
    provide('categoryTab', {
      categoryTab,
      switchCategory
    });
    const commonState = useState('common', ['signPopup', 'palcodePopup', 'palcodeSuccessPopup', 'nicknameEditPopup', 'avatarUploadPopup']);
    let {
      signPopup,
      palcodePopup,
      palcodeSuccessPopup,
      nicknameEditPopup,
      avatarUploadPopup
    } = commonState;

    // 切換Header頁籤
    function switchHeaderTab(val) {
      activeHeaderTab.value = val;
      // 切換 heder 路由時.要把圈子換到推薦-全部
      if (previousHeader.value === 'recommend') {
        categoryTab.value = 'all';
      }
      previousHeader.value = val;
    }

    // 切換圈子分類
    function switchCategory(val) {
      categoryTab.value = val.key;
      if (categoryTab.value === 'recommend') {
        switchHeaderTab('recommend');
        return;
      }
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view, {
        name: "headerPC"
      }), _createElementVNode("main", null, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [_unref(route).meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: 0
        })) : _createCommentVNode("", true)], 1024)), !_unref(route).meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      })]), _createVNode(_component_router_view, {
        name: "footerPC"
      }), _createVNode(_unref(loginBoxPC)), _unref(signPopup).show ? (_openBlock(), _createBlock(_unref(SignPopupPC), {
        key: 0
      })) : _createCommentVNode("", true), _unref(avatarUploadPopup).show ? (_openBlock(), _createBlock(_unref(AvatarUploadPC), {
        key: 1
      })) : _createCommentVNode("", true), _unref(nicknameEditPopup).show ? (_openBlock(), _createBlock(_unref(NicknameEditPC), {
        key: 2
      })) : _createCommentVNode("", true), _unref(palcodePopup).show ? (_openBlock(), _createBlock(_unref(PalcodePopup), {
        key: 3
      })) : _createCommentVNode("", true), _unref(palcodeSuccessPopup).show ? (_openBlock(), _createBlock(_unref(PalcodeSuccessPopup), {
        key: 4
      })) : _createCommentVNode("", true)]);
    };
  }
};